import styled from "styled-components";
import { percentageFilter } from "app/filters/ngFilters";
import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { FlexWithSpace } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import { Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";

const FractionLength = 2;

const TrafficShareContainer = styled(FlexWithSpace)`
    align-items: center;
    height: 36px;
    width: 108px;
    font-size: 14px;
`;

const ProgressCellContainer = styled.div`
    width: 46px;
`;

const TrafficShare = ({ totalShare, hideZeroValue = true }: { totalShare: number; hideZeroValue?: boolean }) => {
    const isZeroShare = totalShare === 0;
    const shouldHideValue = isZeroShare && hideZeroValue;
    const width = totalShare ? totalShare * 100 : 0;
    return (
        <TrafficShareContainer className="traffic-share-container">
            <Text>{shouldHideValue ? "N/A" : percentageFilter()(totalShare, FractionLength) + "%"}</Text>
            {!shouldHideValue ? (
                <ProgressCellContainer className="progress-cell-container">
                    <ProgressBar width={width} />
                </ProgressCellContainer>
            ) : null}
        </TrafficShareContainer>
    );
};

export default TrafficShare;
